// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1__01","cls2":"OnboardingTour-cls2_Y_K OnboardingTour-cls1__01"};